module.exports = __webpack_public_path__ + "img/logo_title_black.c6aadd59.svg";